import { useQuery } from "@tanstack/react-query";
import { useLanguage } from "@/components/LanguageProvider";
import type { ServerTextTranslate } from "@shared/serverText";

type NotificationTextModule = typeof import("@shared/notificationText");
let mod: NotificationTextModule | null = null;

/**
 * The bell's notification text in the reader's language. shared/notificationText
 * compiles its catalogue on load, so it is fetched in its own chunk — and only
 * off English, where it is needed; in English the text is shown as stored.
 */
export function useNotificationText(t: ServerTextTranslate): (text: string | null | undefined) => string {
  const { language } = useLanguage();
  useQuery({
    queryKey: ["/notification-text"],
    queryFn: () => import("@shared/notificationText").then((m) => ((mod = m), true)),
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: language !== "en",
  });
  return (text) => (language !== "en" && mod ? mod.localizeNotificationText(text, t) : text ?? "");
}
